import { useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FolderIcon from "@mui/icons-material/Folder";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MediaQuery from "react-responsive";
import "./pastaMkt.css";
import { useHome } from "../Home/useHome";
import { useDashboardData } from "../../hooks/useDashboardData";

const Equipamentos = (props) => {
  const [loading, setLoading] = useState(true);
  console.log(loading);
  const [state, setState] = useState({
    ns: "",
    open: false,
    openSnackbar: false,
    loading: false,
    codparc: "",
    codprod: "",
    temporario: false,
    temp_key: [],
    disparos_temp: [],
    pasta: null,
    imagem: null,
    formdata: null,
    ...props,
  });

  const handleDelay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleInitialData = async () => {
    setLoading(true);
    await handleDelay(3000);
    const parsedDados =
      typeof props.dados === "string" ? JSON.parse(props.dados) : props.dados;
    updateState({ dados: parsedDados });
    setLoading(false);
  };

  const updateState = (updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  };

  useEffect(() => {
    handleInitialData();
  }, []);

  let { dados } = state;

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height={200}
      >
        <CircularProgress />
      </Box>
    );
  }

  try {
    const parsedDados =
      typeof props.dados === "string" ? JSON.parse(props.dados) : props.dados;
    dados = parsedDados;
  } catch (e) {
    return (
      <h2>
        Sua sessão expirou. Clique <a href="/portal">aqui</a> para logar
        novamente
      </h2>
    );
  }

  const dados_eqp = dados.map((linha) => (
    <TableRow
      hover
      key={linha[0]}
      onClick={() => {
        if (linha) {
          updateState({
            pasta:
              linha[2].indexOf("-") > -1
                ? linha[2]
                : linha[3] === "3010700"
                  ? `${linha[2]} - AV`
                  : linha[3] == "3010500"
                    ? `${linha[2]} - NR`
                    : linha[3] === "3010900"
                      ? `${linha[2]} - RF`
                      : linha[2],
          });
        }
      }}
      sx={{ cursor: "pointer" }}
    >
      <TableCell sx={{ padding: 0 }}>
        <IconButton>
          <FolderIcon />
        </IconButton>
      </TableCell>
      <TableCell>
        {linha[2] && linha[2].indexOf("-") > -1
          ? linha[1]
          : linha[3] === "3010700"
            ? `${linha[1]} - AV`
            : linha[3] == "3010500"
              ? `${linha[1]} - NR`
              : linha[3] === "3010900"
                ? `${linha[1]} - RF`
                : linha[1]}
      </TableCell>
    </TableRow>
  ));

  const is_null = dados.every((elemento) => elemento === null);

  const equip = (
    <Grid
      container
      direction="row"
      justifyContent="space-around"
      alignItems="center"
    >
      <Typography variant="h6" marginBottom={1} width="100%" fontWeight="bold">
        Apoio de Marketing
      </Typography>
      <Typography variant="p" marginBottom={4} width="100%">
        Aqui você encontra documentos, imagens e arquivos importantes referente
        às tecnologias adquiridas. Assista aos videos e apresentações de eventos
        e tenha em mãos as imagens que a sua clinica precisa para divulgação do
        produto
      </Typography>

      <MediaQuery orientation="landscape">
        <TableContainer>
          {!is_null ? (
            <Table size="small" sx={{ minWidth: 650 }} xs={12}>
              <TableHead />
              <TableBody>{dados_eqp}</TableBody>
            </Table>
          ) : (
            <p>
              Não foi encontrado nenhum produto cadastrado nesse CPF ou CNPJ.
            </p>
          )}
        </TableContainer>
      </MediaQuery>

      <MediaQuery orientation="portrait">
        {!is_null ? (
          dados_eqp
        ) : (
          <p>Não foi encontrado nenhum produto cadastrado nesse CPF ou CNPJ.</p>
        )}
      </MediaQuery>
    </Grid>
  );

  const iframe = (
    <Box>
      <Paper sx={{ mb: 3 }}>
        <IconButton
          onClick={() => updateState({ pasta: null })}
          sx={{
            borderRadius: 0,
          }}
        >
          <ArrowBackIcon />
          <Typography
            sx={{
              marginLeft: 1,
            }}
          >
            Voltar para o menu
          </Typography>
        </IconButton>
      </Paper>

      <Paper>
        <iframe
          id="microsoft"
          title={`pasta-iframe-${state.pasta || "default"}`}
          width="100%"
          height="600vh"
          style={{ border: 0 }}
          src={state.pasta}
        />
      </Paper>
    </Box>
  );

  return state.pasta == null ? equip : iframe;
};

export default Equipamentos;
